// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3gNvD","col":"styles_col__RGc2h"};